export interface DefaultOverdueFilters {
  fromDate: string;
  toDate: string;
  badgeFilter: string;
  selectedCreditor: string;
  selectedType: string;
  globalIdContains: string;
  searchText: string;
}

const pad2 = (value: number) => String(value).padStart(2, '0');

export const getDefaultOverdueFilters = (referenceDate: Date = new Date()): DefaultOverdueFilters => {
  const year = referenceDate.getFullYear();
  const month = referenceDate.getMonth();
  const lastDay = new Date(year, month + 1, 0).getDate();
  return {
    fromDate: `${year}-${pad2(month + 1)}-01`,
    toDate: `${year}-${pad2(month + 1)}-${pad2(lastDay)}`,
    badgeFilter: 'VENCIDA',
    selectedCreditor: '',
    selectedType: '',
    globalIdContains: '',
    searchText: '',
  };
};

export const isOverdueDateRangeValid = (fromDate: string, toDate: string): boolean => {
  if (!fromDate || !toDate) return true;
  return toDate >= fromDate;
};

export type OverdueSortConfig = {
  field: string | null;
  direction: 'asc' | 'desc' | null;
};

/** Same column: asc⇄desc. New column always starts asc. */
export const nextOverdueSortConfig = (
  current: OverdueSortConfig,
  field: string,
): OverdueSortConfig => {
  if (current.field === field && current.direction === 'asc') {
    return { field, direction: 'desc' };
  }
  return { field, direction: 'asc' };
};

export const resolveCsvFilename = (contentDisposition?: string, referenceDate: Date = new Date()): string => {
  const fromHeader = contentDisposition?.match(/filename="?([^";]+)"?/)?.[1];
  if (fromHeader) return fromHeader;
  const d = referenceDate;
  return `vencimientos_${d.getFullYear()}${pad2(d.getMonth() + 1)}${pad2(d.getDate())}_${pad2(d.getHours())}${pad2(d.getMinutes())}.csv`;
};
